import {useIntl} from 'react-intl'
import {RoleModel} from '../../../../app/modules/auth/core/_models'


export function RoleHelper(role : string | undefined, currentRole? : string){
  const intl = useIntl()

  let localeRole = ''
  if(role === undefined)
    return localeRole

  if(role === RoleModel.Admin && (currentRole === undefined || currentRole===RoleModel.Admin))
    localeRole = intl.formatMessage({ id: 'fcs' })
  else if(role === RoleModel.InstitutionManager)
    localeRole = intl.formatMessage({ id: 'qdo' })
  else if(role === RoleModel.SchoolManager)
    localeRole = intl.formatMessage({ id: 'nvx' })
  else if(role === RoleModel.Teacher)
    localeRole = intl.formatMessage({ id: '8hp' })
  else if(role === RoleModel.Customer)
    localeRole = intl.formatMessage({ id: 'vxt' })
  else if(role === RoleModel.Person)
    localeRole = intl.formatMessage({ id: 'pb0' })
  else if(role === RoleModel.Employee)
    localeRole = intl.formatMessage({ id: '4ny' })
  else if(role === RoleModel.GuidanceManager)
    localeRole = intl.formatMessage({ id: 'jnd' })
  else if(role === RoleModel.GuidanceCoordinator)
    localeRole = intl.formatMessage({ id: '7zc' })
  
  return localeRole 
}

